import SidebarBookingsDetailsRoute from 'uplisting-frontend/pods/-sidebar/bookings/details/route';

export default class ProtectionOverviewBookingsDetailsRoute extends SidebarBookingsDetailsRoute {
  parentRoute = 'protection.overview.bookings';
}
